import { render, staticRenderFns } from "./inteDetail.vue?vue&type=template&id=718d7326"
import script from "./inteDetail.vue?vue&type=script&lang=js"
export * from "./inteDetail.vue?vue&type=script&lang=js"
import style0 from "./inteDetail.vue?vue&type=style&index=0&id=718d7326&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports